// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root-header {
  background-color: #fff;
  padding: 0.75rem 1.5rem;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  position: relative;
  z-index: 1000;
}

/* Sidebar toggle button */
.sidebar-toggle {
  background: none;
  border: none;
  outline: transparent;
  color: #333;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.sidebar-toggle:hover {
  transform: scale(1.1);
}

/* Mobile menu button */
.mobile-menu-button {
  background: none;
  border: none;
  color: inherit;
  padding: 0.5rem;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

/* Search container */
.search-container {
  flex: 1 1;
  min-width: 200px;
  max-width: 600px;
  margin: 0 1rem;
}

.search-container.mobile-visible {
  display: block;
  width: 100%;
  order: 3;
  margin: 0.5rem 0 0 0;
}

.inputSearch {
  position: relative;
  width: 100%;
}

/* Mobile search toggle */
.mobile-search-toggle {
  background: none;
  border: none;
  color: #555;
  margin-left: auto;
}

/* Header right elements */
.header-right-elements {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

/* Notification */
.notification-wrapper {
  position: relative;
  cursor: pointer;
  padding: 0.5rem;
}

.notification-badge {
  position: absolute;
  top: 0;
  right: 0;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  font-weight: bold;
}

/* Language selector */
.lang-switch {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.language-flag {
  width: 36px;
  height: 24px;
  border-radius: 25%;
  overflow: hidden;
}

.language-flag img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Header divider */
.header-divider {
  height: 24px;
  width: 1px;
  background-color: #e0e0e0;
  margin: 0 0.25rem;
}

/* Profile dropdown */
.profile-dropdown {
  margin-left: 0.5rem;
}

.profile-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.admin-photo {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
}

.logout-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  color: #333;
}

.logout-icon {
  font-size: 1.1rem;
}

/* Mobile navigation menu */
.mobile-nav-menu {
  width: 250px;
  max-height: 80vh;
  overflow-y: auto;
  margin-top: 0.5rem;
}

.mobile-nav-item {
  padding: 0.75rem 1rem;
  white-space: nowrap;
}

.mobile-nav-item:hover {
  background-color: #f8f9fa;
}

.mobile-nav-icon {
  font-size: 1.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .search-container {
    max-width: 400px;
  }
}

@media (max-width: 768px) {
  .root-header {
    padding: 0.75rem 1rem;
  }
  
  .search-container:not(.mobile-visible) {
    display: none;
  }
  
  .mobile-search-toggle {
    display: block;
  }
  
  .header-right-elements {
    gap: 0.5rem;
  }
}

@media (max-width: 576px) {
  .root-header {
    padding: 0.5rem;
  }
  
  .language-flag {
    width: 30px;
    height: 20px;
  }
  
  .admin-photo {
    width: 32px;
    height: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yDAA6P;EAC7P,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".root-header {\n  background-color: #fff;\n  padding: 0.75rem 1.5rem;\n  border-bottom: 1px solid #e0e0e0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  position: relative;\n  z-index: 1000;\n}\n\n/* Sidebar toggle button */\n.sidebar-toggle {\n  background: none;\n  border: none;\n  outline: transparent;\n  color: #333;\n  padding: 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.3s ease;\n}\n\n.sidebar-toggle:hover {\n  transform: scale(1.1);\n}\n\n/* Mobile menu button */\n.mobile-menu-button {\n  background: none;\n  border: none;\n  color: inherit;\n  padding: 0.5rem;\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n/* Search container */\n.search-container {\n  flex: 1;\n  min-width: 200px;\n  max-width: 600px;\n  margin: 0 1rem;\n}\n\n.search-container.mobile-visible {\n  display: block;\n  width: 100%;\n  order: 3;\n  margin: 0.5rem 0 0 0;\n}\n\n.inputSearch {\n  position: relative;\n  width: 100%;\n}\n\n/* Mobile search toggle */\n.mobile-search-toggle {\n  background: none;\n  border: none;\n  color: #555;\n  margin-left: auto;\n}\n\n/* Header right elements */\n.header-right-elements {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n/* Notification */\n.notification-wrapper {\n  position: relative;\n  cursor: pointer;\n  padding: 0.5rem;\n}\n\n.notification-badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  color: white;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.65rem;\n  font-weight: bold;\n}\n\n/* Language selector */\n.lang-switch {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.language-flag {\n  width: 36px;\n  height: 24px;\n  border-radius: 25%;\n  overflow: hidden;\n}\n\n.language-flag img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Header divider */\n.header-divider {\n  height: 24px;\n  width: 1px;\n  background-color: #e0e0e0;\n  margin: 0 0.25rem;\n}\n\n/* Profile dropdown */\n.profile-dropdown {\n  margin-left: 0.5rem;\n}\n\n.profile-toggle {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.admin-photo {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.logout-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  color: #333;\n}\n\n.logout-icon {\n  font-size: 1.1rem;\n}\n\n/* Mobile navigation menu */\n.mobile-nav-menu {\n  width: 250px;\n  max-height: 80vh;\n  overflow-y: auto;\n  margin-top: 0.5rem;\n}\n\n.mobile-nav-item {\n  padding: 0.75rem 1rem;\n  white-space: nowrap;\n}\n\n.mobile-nav-item:hover {\n  background-color: #f8f9fa;\n}\n\n.mobile-nav-icon {\n  font-size: 1.25rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 992px) {\n  .search-container {\n    max-width: 400px;\n  }\n}\n\n@media (max-width: 768px) {\n  .root-header {\n    padding: 0.75rem 1rem;\n  }\n  \n  .search-container:not(.mobile-visible) {\n    display: none;\n  }\n  \n  .mobile-search-toggle {\n    display: block;\n  }\n  \n  .header-right-elements {\n    gap: 0.5rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .root-header {\n    padding: 0.5rem;\n  }\n  \n  .language-flag {\n    width: 30px;\n    height: 20px;\n  }\n  \n  .admin-photo {\n    width: 32px;\n    height: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
